/** Shared lead-in HTML helpers for the question composer and authoring utilities. */

export function isLeadInRichHtml(value: string): boolean {
  return /^<(?:p|h[23]|ul|ol|blockquote|div)/i.test(value.trim())
}

export function escapeLeadInHtml(text: string): string {
  return text
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
}

/** Plain text or legacy import → TipTap HTML for the lead-in editor. */
export function leadInToEditorHtml(leadIn: string): string {
  if (!leadIn.trim()) return ""
  if (isLeadInRichHtml(leadIn)) return leadIn
  const escaped = escapeLeadInHtml(leadIn).replace(/\n/g, "<br>")
  return `<p>${escaped}</p>`
}

/** Visible prompt text (strip HTML tags). */
export function leadInPlainText(leadIn: string): string {
  if (!leadIn.trim()) return ""
  if (!isLeadInRichHtml(leadIn)) return leadIn.replace(/\s+/g, " ").trim()
  if (typeof DOMParser !== "undefined") {
    const doc = new DOMParser().parseFromString(leadIn, "text/html")
    return (doc.body.textContent ?? "").replace(/\s+/g, " ").trim()
  }
  return leadIn
    .replace(/<[^>]+>/g, " ")
    .replace(/\s+/g, " ")
    .trim()
}

export function leadInPlainTextLength(leadIn: string): number {
  return leadInPlainText(leadIn).length
}

export function isLeadInRichTextEmpty(html: string): boolean {
  return leadInPlainTextLength(html) === 0
}
